import * as sanitize from 'sanitize-html';

const options: sanitize.IOptions = {
  allowedAttributes: {
    a: []
  },
  allowedTags: ['h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'ul', 'ol',
    'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'hr', 'br', 'div',
    'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre', 'a']
};

export const sanitizeHtml = (html: string) => sanitize(html, options);


// WEBPACK FOOTER //
// ./src/components/mail/util/sanitize.ts